import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnChanges, Output, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { OneWebComponentsAngularModule } from '@one/angular';
import { ReminderTableComponent } from '../reminder-table/reminder-table.component';
import { toHTML } from 'ngx-editor';
import { HttpErrorResponse } from '@angular/common/http';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QnSbnService } from '../../../services/qn-sbn-service.service';
import { QnSbnDataServiceService } from '../../../services/qn-sbn-data-service.service';
import { CreateReminderDialogService } from '../create-reminder-dialog.service';
import { RichTextDocumentComponent } from '../../richTextDocument/rich-text-document/rich-text-document.component';
import { CommonModule, formatDate } from '@angular/common';
import { DateType, snackbarService } from '@one/web-components';

@Component({
  selector: 'dl-create-reminder',
  standalone: true,
  imports: [OneWebComponentsAngularModule, FormsModule, ReactiveFormsModule, RichTextDocumentComponent, CommonModule],
  templateUrl: './create-reminder.component.html',
  styleUrl: './create-reminder.component.scss'
})
export class CreateReminderComponent implements OnChanges {
  spinnerBool: any;
  
  @ViewChild('reminderDatepicker') reminderDatepicker: any;

  public constructor(
    private qnsbnservice: QnSbnService,
    private _QnSbnDataService: QnSbnDataServiceService,
    private createReminderDialogService: CreateReminderDialogService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {

  }
  @Input() data: any;

  @Output() dialogClose = new EventEmitter<any>();

  @Input() public reminderRTEDoc: string = '';
  public feedbackDueDate: string;
  public feedbackDueDateRaw: Date | null = null;
  public reminderFormattedDate: Date;
  public dueDateDiff: number;
  public isEditRow = false;
  public prevReminderData: any = null;
  public reminderDate = new FormControl(null);
  public dateShortcut: FormControl = new FormControl('');
  public reminderConsent: FormControl = new FormControl('');
  public isReminderFormComplete = false;
  public subjectName = new FormControl();
  public addTempleteCheck = false;
  public remindersData = this.createReminderDialogService.getRemindersDate() || [];
  public selectedConcent: any;
  public isTemplateDisabled: boolean;
  public templateData: any;
  public createReminderTxt: any;
  public templateSubject: string = '';
  public templateEmailText: string = '';
  public templateId: string = '';
  public templateColumn = ['dragHandle', 'selectText', 'messageTemplate', 'iconSets'];
  public disabledApplyCheckbox = true;
  public notificationData: any;
  public keyUpForRTE = false;
  public keyUpForSubjectName = false;
  public feedbackDueDateForRadio: string = '';
  public isDataLoaded = false; // Flag to control rendering
  public datePickerKey = 0; // Key to force re-render datepicker

  value: Date | DateType[] | number;

  public reminderDateFilter = (d: Date | null): boolean => {
    const startDate = d || new Date();
    const reminderDates = this.remindersData.map(reminder => reminder['reminderDate']);
    if (this.data.isEdit) {
      return startDate >= new Date() && !reminderDates.find(x => new Date(x).getDate() == startDate.getDate() && new Date(x).getDate() !== new Date(this.data.reminderData.reminderDate).getDate());
    } else {
      return startDate >= new Date() && !reminderDates.find(x => new Date(x).getDate() == startDate.getDate());
    }
  }

  public toggleApplyButton(evt: boolean): void {
    this.addTempleteCheck = evt;
  }

  public setDateFilter(value: number): void {
    const nextDate = new Date();
    nextDate.setDate(nextDate.getDate() + value);
  }

  public formatDate(value: Date): string {
    const date = new Date(value);
    const day = date.toLocaleString('en-US', { day: '2-digit' });
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.toLocaleString('en-US', { year: 'numeric' });
    return day + '-' + month + '-' + year;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && changes['data'].currentValue) {
      const incomingData = changes['data'].currentValue;
      this.spinnerBool = changes['data'].currentValue;
     
      // Force destroy the datepicker
      this.isDataLoaded = false;

      if (incomingData?.notificationData) {
        this.notificationData = incomingData.notificationData;
      }
      
      // Handle feedbackDueDate - it can be a Date, FormControl, or FormControl value
      let feedbackDateValue = incomingData?.feedbackDueDate;
      if (feedbackDateValue && typeof feedbackDateValue.value !== 'undefined') {
        // It's a FormControl, get the value
        feedbackDateValue = feedbackDateValue.value;
      }
      
      const rawDateForFeedback: Date = feedbackDateValue ? new Date(feedbackDateValue) : new Date();
      this.feedbackDueDate = formatDate(rawDateForFeedback, 'dd-MMM-yyyy', 'en-US');
      this.createReminderDialogService.setFeedbackDueDate(rawDateForFeedback);
      this.feedbackDueDateRaw = new Date(rawDateForFeedback.getTime());
      
      
      this.feedbackDueDateForRadio = formatDate(rawDateForFeedback, 'd/M/yyyy', 'en-US');

      const today = new Date();
      const diffTime = rawDateForFeedback.getTime() - today.getTime();
      this.dueDateDiff = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      this.isEditRow = incomingData?.isEdit;
      this.prevReminderData = incomingData?.reminderData;
      const reminderData = incomingData.reminderData;
      if (reminderData) {
        if (reminderData?.reminderDate) {
          const rawDate = this.parseReminderDate(reminderData.reminderDate);
          this.reminderDate.setValue(rawDate);
        }

        this.subjectName.setValue(reminderData.reminderSubject || '');
        this.reminderRTEDoc = reminderData.reminderMessage || '';
        this.reminderConsent.setValue(reminderData.reminderSendMode ?? '');
        this.createReminderTxt = reminderData.reminderMessage || '';
      } else {
        // Reset form fields when no reminder data (new reminder)
        this.reminderDate.setValue(null);
        this.subjectName.setValue('');
        this.reminderRTEDoc = '';
        this.reminderConsent.setValue('');
        this.createReminderTxt = '';
      }
      this.subjectName.valueChanges.subscribe(() => {
        this.getApplybuttonStatus();
      });
      
      // Update checkbox disabled state based on current data
      this.getApplybuttonStatus();
      
      // Wait for feedbackDueDateRaw to be set, then recreate the datepicker
      setTimeout(() => {
        this.isDataLoaded = true;
        this.changeDetectorRef.detectChanges();
      }, 50);
    }

  }

  private parseReminderDate(dateStr: string): Date {
    const [day, monthStr, year] = dateStr.split('-');
    const monthMap: { [key: string]: number } = {
      Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
      Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11
    };
    const month = monthMap[monthStr];
    return new Date(+year, month, +day);
  }


  public radioChange(event: any): void {
    const rawValue = event?.detail;
    const daysBefore = parseInt(rawValue, 10);
    if (!this.feedbackDueDateRaw || isNaN(daysBefore)) return;
    const reminderDate = new Date(this.feedbackDueDateRaw.getTime());
    reminderDate.setDate(reminderDate.getDate() - daysBefore);

    this.reminderDate.setValue(reminderDate);
    this.changeDetectorRef.detectChanges();
  }

  public onReminderDateSelected(event: any): void {
    this.closeDatepicker();
  }

  private closeDatepicker(): void {
   
    
    setTimeout(() => {
      if (this.reminderDatepicker) {
        const datepicker = this.reminderDatepicker.nativeElement || this.reminderDatepicker;
      
        if (datepicker.opened !== undefined) {
          datepicker.opened = false;
         
        }
        if (typeof datepicker.close === 'function') {
          datepicker.close();
         
        }
        if (datepicker.hide && typeof datepicker.hide === 'function') {
          datepicker.hide();
         
        }
        
       
        const input = datepicker.querySelector('input');
        if (input) {
          input.blur();
        }
      }
      this.changeDetectorRef.detectChanges();
    }, 100);
  }


  public ngOnInit(): void {
   

    this.isTemplateDisabled = !this._QnSbnDataService.template;

    this._QnSbnDataService.mappingData$.subscribe(observer => {
      // Only update notificationData from service if NOT set from input (dialog mode)
      // This prevents overwriting the data passed via @Input
      if (!this.notificationData || Object.keys(this.notificationData).length === 0) {
        if (!this._QnSbnDataService.isEmpty(observer['localNotificationId'])) {
          this.notificationData = observer['localNotificationId'];
        }
      }

      if (!this._QnSbnDataService.isEmpty(observer['reminderAttachment'])) {
        const templateSubject = observer['reminderAttachment']['reminderSubjectName'];
        const templateEmailText = observer['reminderAttachment']['reminderAttachmentRTEText'];
        const templateId = observer['reminderAttachment']['templateId'];

        this.templateSubject = templateSubject;
        this.templateEmailText = templateEmailText;
        this.templateId = templateId;
        if (!this.subjectName.value) {
          this.subjectName.setValue(templateSubject);
        }

        if (!this.reminderRTEDoc || this.reminderRTEDoc === '<p></p>') {
          this.reminderRTEDoc = templateEmailText;
        }

        if (!this.createReminderTxt || this.createReminderTxt === '<p></p>') {
          this.createReminderTxt = templateEmailText;
        }
      }
    });
    this.createReminderDialogService.setDate(this.reminderDate);
    
   
    this.reminderDate.valueChanges.subscribe(value => {
      if (value) {
       
        this.closeDatepicker();
      }
    });
  }


  public ngAfterViewInit() {
    if (this.isEditRow === false && this.data?.isBlank === true) {
      this.subjectName.setValue('');
      this.reminderRTEDoc = '<p></p>';
      this.createReminderTxt = '<p></p>';
      this.reminderConsent.setValue('');
      this.reminderDate.setValue('');
    }
  }

  public addReminder(): void {
    const parsedDate = new Date(this.reminderDate.value);

    // Check for duplicate reminder date
    if (this.isDuplicateReminderDate(parsedDate)) {
      this.snackBarMessage('alarm', 'A reminder already exists for this date. Please select a different date.');
      return;
    }

    const reminderData = [
      {
        reminderDate: this.formatDate(parsedDate),
        reminderSubject: this.subjectName.value,
        reminderMessage: this.createReminderTxt || this.reminderRTEDoc,
        reminderSendMode: this.reminderConsent.value,
        reminderActionIcons: true
      }
    ];

    if (this.addTempleteCheck) {
      this.onApplybuttonAction();
    }

   
    this.dialogClose.emit({ data: reminderData, addToTemplate: this.addTempleteCheck });
    this.changeDetectorRef.detectChanges();
    
    if (this.addTempleteCheck) {
      this.snackBarMessage('positive', 'Reminder successfully added to notification, reminder message successfully added to your templates');
    } else {
      this.snackBarMessage('positive', 'Reminder successfully added to notification');
    }
  }

  public updateReminder(): void {
    const parsedDate = new Date(this.reminderDate.value);

    // Check for duplicate reminder date (excluding the current reminder being edited)
    if (this.isDuplicateReminderDate(parsedDate, true)) {
      this.snackBarMessage('alarm', 'A reminder already exists for this date. Please select a different date.');
      return;
    }

    const reminderData = [
      {
        reminderDate: this.formatDate(parsedDate),
        reminderSubject: this.subjectName.value,
        reminderMessage: this.createReminderTxt || this.reminderRTEDoc,
        reminderSendMode: this.reminderConsent.value,
        reminderActionIcons: true
      }
    ];
    
    // If checkbox is checked, save template to database first
    if (this.addTempleteCheck) {
      this.onApplybuttonAction();
    }
    
    // Pass checkbox state to parent dialog
    this.dialogClose.emit({ data: reminderData, addToTemplate: this.addTempleteCheck });
    this.changeDetectorRef.detectChanges();
    
    if (this.addTempleteCheck) {
      this.snackBarMessage('positive', 'Reminder successfully updated to notification, reminder message successfully added to your templates');
    } else {
      this.snackBarMessage('positive', 'Reminder successfully updated to notification');
    }
  }

  // Helper method to check for duplicate reminder dates
  private isDuplicateReminderDate(dateToCheck: Date, isEditMode: boolean = false): boolean {
    if (!this.remindersData || this.remindersData.length === 0) {
      return false;
    }

    const checkDate = new Date(dateToCheck);
    checkDate.setHours(0, 0, 0, 0);

    return this.remindersData.some((reminder: any) => {
      if (!reminder?.reminderDate) return false;

      const reminderDate = this.parseReminderDate(reminder.reminderDate);
      reminderDate.setHours(0, 0, 0, 0);

      // In edit mode, exclude the current reminder being edited
      if (isEditMode && this.prevReminderData?.reminderDate) {
        const prevDate = this.parseReminderDate(this.prevReminderData.reminderDate);
        prevDate.setHours(0, 0, 0, 0);
        
        // If this is the same reminder being edited, skip it
        if (reminderDate.getTime() === prevDate.getTime()) {
          return false;
        }
      }

      return reminderDate.getTime() === checkDate.getTime();
    });
  }

  onCancel() {
    this.dialogClose.emit(null);
  }

  public feedbackDueDateDisabled = (d: Date | null): boolean => {
    if (!d) return true;
    
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    const checkDate = new Date(d);
    checkDate.setHours(0, 0, 0, 0);
    
    if (checkDate <= today) {
      return true;
    }
    
    
    if (this.feedbackDueDateRaw) {
      const dueDate = new Date(this.feedbackDueDateRaw);
      dueDate.setHours(0, 0, 0, 0);
      
     
      if (checkDate >= dueDate) {
        return true;
      }
    }
    
    
    if (this.remindersData && this.remindersData.length > 0) {
      const isDateUsed = this.remindersData.some((reminder: any) => {
        if (!reminder?.reminderDate) return false;
        
        const reminderDate = this.parseReminderDate(reminder.reminderDate);
        reminderDate.setHours(0, 0, 0, 0);
        
       
        if (this.isEditRow && this.prevReminderData?.reminderDate) {
          const prevDate = this.parseReminderDate(this.prevReminderData.reminderDate);
          prevDate.setHours(0, 0, 0, 0);
          
          
          if (reminderDate.getTime() === prevDate.getTime()) {
            return false;
          }
        }
        
        
        return reminderDate.getTime() === checkDate.getTime();
      });
      
      if (isDateUsed) {
        return true;
      }
    }
    
   
    return false;
  };

  public getReminderDate(rdd: Date): void {
    const dateValue = rdd instanceof Date ? rdd : new Date(rdd);
    this.isTemplateDisabled = !this.isTemplateDisabled;
  }

  public onKeyupSubjectName(evt) {
    evt.preventDefault();
    this.keyUpForSubjectName = true;
  }

  public onBlurSubjectName(evt) {
    this.subjectName.setValue(this.subjectName.value.trim());
    this.addProduct(this.subjectName.value, this.reminderRTEDoc);
  }

  public createTemplateUsingApply(): void {
    // Handle different property names that might come from different API responses
    const notificationType = this.notificationData?.Type || this.notificationData?.NotificationType || this.notificationData?.type;
    const notificationLanguage = this.notificationData?.LocalNotificationLanguage || this.notificationData?.Language || this.notificationData?.language;
    
    
    if (!notificationType || !notificationLanguage) {
      // Show error to user since they explicitly checked the checkbox
      this.snackBarMessage('alarm', 'Cannot save template: notification type or language is missing');
      return;
    }

    const newTemplateData = {
      "templateSubject": this.subjectName.value,
      "templateBody": this.reminderRTEDoc,
      "notificationType": notificationType,
      "messageType": "Reminder",
      "templateLanguage": notificationLanguage
    };

   

    this.qnsbnservice.createUpdateMessageTemplate(newTemplateData).subscribe({
      next: (responseData: any) => {
        console.log('Template saved successfully:', responseData);
        this.addProduct(responseData.templateSubject, responseData.templateBody);
        this.addTempleteCheck = false;
        this.disabledApplyCheckbox = true;
        this.changeDetectorRef.detectChanges();
      },
      error: (error: HttpErrorResponse) => {
        this.qnsbnservice.httpErrorHandler(error, 'Could not save reminder template.');
      }
    });

  }

  public onApplybuttonAction(): void {
    this.createTemplateUsingApply();
  }

  public chkApplyChange(values: any): void {
    if (values.checked) {
      this.onApplybuttonAction()
    }
  }

  public setRTEText(evt): void {
    this.createReminderTxt = toHTML(evt);
    const newText = toHTML(evt);
    if (this.reminderRTEDoc === newText) {
      return;
    } else {
      this.reminderRTEDoc = newText;
      this.getApplybuttonStatus();
      this.addProduct(this.subjectName.value, this.reminderRTEDoc);
    }
  }

  public getApplybuttonStatus(): void {
    if (this.subjectName.status === 'VALID' && this.reminderRTEDoc && this.reminderRTEDoc !== '<p></p>') {
      this.disabledApplyCheckbox = false;
    } else {
      this.disabledApplyCheckbox = true;
    }
  }

  public addProduct(subjectName, docRTEtext) {
    this._QnSbnDataService.getMappedQnsbnData({
      "reminderSubjectName": subjectName,
      "reminderAttachmentRTEText": docRTEtext,
      "templateId": this.templateId || ""
    }, "reminderAttachment");
  }

  ngOnDestroy(): void {
    this.addProduct(this.subjectName.value, this.reminderRTEDoc);
  }

  snackBarMessage(status: any, message: string) {
    snackbarService.show({
      message: message,
      snackbarProps: {
        status: status,
        direction: 'horizontal',
        showClose: true,
        elevated: false,
        duration: 5000,
        verticalPlacement: 'top',
        horizontalPlacement: 'right',
      }
    });
  }
}
